import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import CarCardsGroup from "@/pages/landingPages/components/CarCardsGroup/CarCardsGroup";
import useHelpers from "@hooks/useHelpers";
var DEFAULT_NUMBER_OF_CARS = 12;
var BrowseCarsBy = function BrowseCarsBy(_ref) {
  var products = _ref.products,
    number_of_cars = _ref.number_of_cars,
    title = _ref.title,
    url = _ref.url,
    cta = _ref.cta,
    _ref$headingType = _ref.headingType,
    headingType = _ref$headingType === void 0 ? "h2" : _ref$headingType;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  url = url || createUrl(cta === null || cta === void 0 ? void 0 : cta.url) || createUrl("/filters", _defineProperty({}, "condition_id", 0));
  number_of_cars = number_of_cars || DEFAULT_NUMBER_OF_CARS;
  return /*#__PURE__*/React.createElement(CarCardsGroup, {
    headingType: headingType,
    cta: cta,
    title: title,
    url: url,
    products: products.slice(0, number_of_cars)
  });
};
export default BrowseCarsBy;